import React from "react";

import "./styles.scss";

import { Leaderboard } from "@/services/bedrock";
import { AdminSideBar } from "@/components/SideBarAdmin";
import { LeaderboardTable } from "@/components/LeaderboardTable";
import { LeaderboardModal } from "@/components/LeaderboardModal";
import { WhiteContainer } from "@/styling/baseStyle";
import { useHistory } from "react-router-dom";
import { Header } from "semantic-ui-react";

export const AdminLeaderboards: React.FC = () => {
  const history = useHistory();
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [modalBoard, setModalBoard] = React.useState<Leaderboard>();

  const leaderboards: Leaderboard[][] = [
    [
      { title: "Top Posts", entityType: "post" },
      { title: "Top Scripts", entityType: "video_script" },
      { title: "Top Video Pages", entityType: "content_page" },
    ],
    [
      { title: "Top Coaches", entityType: "coach" },
      { title: "Top Accounts", entityType: "social_identity", startTimeKey: "all" },
      { title: "Top Players", entityType: "player" },
    ],
  ];

  return (
    <WhiteContainer>
      <AdminSideBar history={history} />
      <div className="adminLeaderboards">
        <Header as={"h2"}>Leaderboards</Header>

        <div className={"statTablesContainer"}>
          {leaderboards.map(column => (
            <div className={"leaderboardColumn"}>
              {column.map(board => (
                <div className={"leaderboardContainer"}>
                  <LeaderboardTable
                    key={`leaderboard-${board.entityType}`}
                    title={board.title}
                    adminView={true}
                    perPage={10}
                    entityType={board.entityType}
                    onViewAll={(startTimeKey, metric) => {
                      setModalBoard({
                        ...board,
                        startTimeKey,
                        metric,
                      });
                      setShowModal(true);
                    }}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>

        <LeaderboardModal open={showModal} onClose={() => setShowModal(false)} board={modalBoard} adminView={true} />
      </div>
    </WhiteContainer>
  );
};
